import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { CircleX, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaDemandaCancelada = (acao: string): boolean => {
    const acaoLower = acao.toLowerCase().trim();
    return acaoLower === 'Demanda cancelada' || 
           acaoLower.includes('Demanda cancelada') ||
           acaoLower === 'cancelou' ||
           (acaoLower.includes('cancelou') && acaoLower.includes('demanda'));
};

const getIconDemandaCancelada = (acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: CircleX, color: 'var(--c95a5a6)' };
};

export default function CardDemandaCancelada({ item, onNavigateToFile, isExpanded, onToggleExpand }: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconDemandaCancelada(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={<ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />}
        />
    );
}

export const demandaCanceladaConfig = {
    tipo: 'demanda_cancelada',
    detectaTipo: detectaDemandaCancelada,
    getIcon: getIconDemandaCancelada,
    temExpansao: () => true,
    Component: CardDemandaCancelada
};

